import { Container, Row, Col, Button, Form } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import React, { useEffect, useState } from "react";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import questionnaire_icon from "../../../images/Questionnaire_icon.png";
import Header from "../../Includes/Header";
import BackButton from "../../Includes/BackButton";
import { reduxForm, InjectedFormProps } from "redux-form";
import { setwizardPageNumber, setQuestionnaireScreen6 } from "../../authslice";
import { connect } from "react-redux";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox } from "MyComponents/Toaster";
import { updatePersonalKycDraftStep } from "Utils/personalKycDraft";
import CheckboxGroup from "MyComponents/UI/CheckBoxGroup";
import RadioButtonGroup from "MyComponents/UI/RadioButtonGroup";
import { useTranslation } from 'react-i18next';

interface Props { }

interface CheckboxState {
  checkbox1: boolean;
  checkbox2: boolean;
  checkbox3: boolean;
  checkbox4: boolean;
  checkbox5: boolean;
  checkbox6: boolean;
  checkbox7: boolean;
}

const checkboxLabels = [
  { id: "checkbox1", label: "Self" },
  { id: "checkbox2", label: "Father" },
  { id: "checkbox3", label: "Husband" },
  { id: "checkbox4", label: "Wife" },
  { id: "checkbox5", label: "Children" },
  { id: "checkbox6", label: "Brother" },
  { id: "checkbox7", label: "Sister" },
];

const Questionnaire_Screen6: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();
  const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
  const [isChecked, setIsChecked] = useState(false);
  const [validated, setValidated] = useState(false);
  const [selectedOption, setSelectedOption] = useState("No");
  const [checkboxes, setCheckboxes] = useState<CheckboxState>({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: false,
    checkbox5: false,
    checkbox6: false,
    checkbox7: false,
  });

  const isAtLeastOneCheckboxChecked = Object.values(checkboxes).some((isChecked) => isChecked);

  const handleAcknowledgeCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
    setValidated(false);
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    setCheckboxes((prevCheckboxes) => ({ ...prevCheckboxes, [id]: checked }));
    setValidated(false);
  };

  const handleRadioChange = (e: any) => {
    setSelectedOption(e.target.value);
    setValidated(false);
  };

  const submitForm = async () => {
    setValidated(true);

    if (!isChecked) return;

    if (selectedOption === "No") {
      dispatch(setwizardPageNumber(page + 1));
      localStorage.setItem('pageNumber', `${page + 1}`);
      return;
    }

    if (selectedOption === "Yes") {
      if (!isAtLeastOneCheckboxChecked) return;

      const checkedCheckboxes = Object.entries(checkboxes)
        .filter(([_, value]) => value)
        .map(([key]) => checkboxLabels.find((item) => item.id === key)?.label);

      dispatch(setQuestionnaireScreen6(checkedCheckboxes as string[]));
      dispatch(setwizardPageNumber(page + 1));
      localStorage.setItem('pageNumber', `${page + 1}`);

      const userIDFromRedux = props.userID;
      if (userIDFromRedux) {
        updatePersonalKycDraftStep(userIDFromRedux, 'questionnaire', { screen6: checkedCheckboxes });
        updatePersonalKycDraftStep(userIDFromRedux, 'wizardState', { pageNumber: page + 1 });
      }
    }
  };

  return (
    <>
      <ToastBox />
      <Container fluid className="px-0 px-md-3">
        <Row className="g-0">
          <Col md={12} className="mx-auto px-2 pt-0 pb-3">
            <div className="mt-5">
              <Row className="px-2 px-md-5">
                <Col md={12}><BackButton /></Col>
              </Row>
              <Row className="px-2 px-md-5">
                <Col md={12}>
                  <div className="d-flex align-items-start py-3">
                    <img src={questionnaire_icon} width={48} className="d-none d-md-block me-3 mt-1" alt="Questionnaire Icon" />
                    <div>
                      <h3 className="text-start m-0">{t('kyc.questionnaire')}</h3>
                      <p className="fw-normal text-secondary m-0 mt-1 text-nowrap">{t('kyc.individual_form')}</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="px-2 px-md-5">
                <Col md={12}>
                  <div className="d-none d-md-flex align-items-center">
                    <ProgressBar variant="primary" className="custom_progressbar mr-2" now={60} />
                    <p className="fw-bold small py-3 px-3 m-0">6/7</p>
                  </div>
                  <p className="fw-bold text-start mt-4 m-0">{t('kyc.q6_title')}</p>
                  <p className="text-secondary text-start small mt-1">{t('kyc.q6_desc')}</p>

                  <Form noValidate onSubmit={handleSubmit(submitForm)}>
                    <RadioButtonGroup
                      options={[
                        { id: "yes", value: "Yes", label: "Yes", checked: selectedOption === "Yes" },
                        { id: "no", value: "No", label: "No", checked: selectedOption === "No" },
                      ]}
                      onChange={handleRadioChange}
                    />
                    {selectedOption === "Yes" && (
                      <>
                        <p className="fw-bold m-0 mt-4 mb-2">{t('kyc.q6_how')}</p>
                        {validated && !isAtLeastOneCheckboxChecked && (
                          <p className="text-danger text-start small fw-bold mt-1">{t('common.please_check_one')}</p>
                        )}
                        <CheckboxGroup
                          checkboxes={checkboxLabels.map((checkbox) => ({
                            ...checkbox,
                            checked: checkboxes[checkbox.id as keyof CheckboxState],
                          }))}
                          onCheckboxChange={handleCheckboxChange}
                        />
                      </>
                    )}

                    <Row className="mt-2 text-start">
                      <p className="text-secondary fw-bold m-0">{t('kyc.pep_what')}</p>
                      <p className="text-secondary small py-1 m-0">{t('kyc.pep_desc')}</p>
                      <Form.Group as={Row} className="mb-2 mt-2" controlId="formHorizontalCheck">
                        <Col>
                          <Form.Check
                            required
                            checked={isChecked}
                            onChange={handleAcknowledgeCheckboxChange}
                            className="text-secondary"
                            label={t('kyc.pep_ack')}
                            isInvalid={validated && !isChecked}
                            feedback={t('kyc.please_ack')}
                            feedbackType="invalid"
                          />
                        </Col>
                      </Form.Group>
                    </Row>

                    <Row className="mt-3 text-start mb-2">
                      <Col md={8}>
                        <Button type="submit" className="btn btn-primary rounded-5" style={{ width: "220px" }}>
                          {t('common.next')}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: "wizard",
  enableReinitialize: true,
})(Questionnaire_Screen6);

export default connect(null)(form);
